/* lua.js generated code 0.3.0 */

ObjectPool = xClass("ObjectPool")
var _instance = null
var _instanceHome = null
var _instanceBrick = null
ObjectPool.getInstance = function () {
    if (!_instance) {
        _instance = ObjectPool.new()
    }
    return _instance
}
ObjectPool.getBrickSceneInstance = function () {
    if (!_instanceBrick) {
        _instanceBrick = ObjectPool.new()
    }
    return _instanceBrick
}
ObjectPool.getHomeInstance = function () {
    if (!_instanceHome) {
        _instanceHome = ObjectPool.new()
    }
    return _instanceHome
}
ObjectPool.prototype.ctor = function () {
    var self = this
    self.cache = {}
    self.free = {}
    self.pawn = {}
    self.freeSet = new Set()
}
ObjectPool.prototype.preload = function (tag, pawn, num) {
    var __VA_ARG = $slice(arguments, 3)
    var self = this
    if (self.pawn[tag]){
        console.warn("[Object-Pool]tag already exist,callback maybe error please check! tag:"+tag)
        return
    }
    //assert(!self.pawn[tag])
    assert(type(pawn) === "function")
    self.cache[tag] = self.cache[tag] || sTable()
    self.free[tag] = self.free[tag] || sTable()
    self.pawn[tag] = pawn
    self.freeSet[tag] = new Set()
    var $limit6 = num
    for (var i = 1; i <= $limit6; i += 1) {
        var obj = self.pawn[tag](...__VA_ARG)
        // obj.retain()
        table.insert(self.cache[tag], obj)
        table.insert(self.free[tag], obj)
        self.freeSet[tag].add(obj)
    }

}
ObjectPool.prototype.get = function (tag) {
    var self = this
    assert(type(self.pawn[tag]) === "function")
    self.cache[tag] = self.cache[tag] || sTable()
    self.free[tag] = self.free[tag] || sTable()
    if ($len(self.free[tag]) < 1) {
        var __VA_ARG = $slice(arguments, 1)
        var obj = self.pawn[tag](...__VA_ARG)
        // obj.retain()
        table.insert(self.cache[tag], obj)
        return obj
    }
    if (!self.freeSet[tag]) {
        self.freeSet[tag] = new Set()
    }
    var obj = table.remove(self.free[tag])
    self.freeSet[tag].delete(obj)
    return obj
}
ObjectPool.prototype.collect = function (tag, obj, cleanup = true) {
    var self = this
    if (!obj) {
        return
    }
    if (self.freeSet[tag] == null) {
        self.freeSet[tag] = new Set()
        cc.log("ObjectPool.freeSet is empty , " + tag)
    }
    if (self.freeSet[tag].has(obj)) {
        //cc.log("freeSet duplication of obj, "+tag+" size:" + self.free[tag].length)
        return
    }
    if (cleanup) {
        if (obj.cleanup) obj.cleanup();
        if (obj.release) obj.release()
    }
    self.freeSet[tag].add(obj)
    self.free[tag] = self.free[tag] || sTable()
    //self.freemap[tag] = self.freemap[tag] || sTable()
    table.insert(self.free[tag], obj)
}
ObjectPool.prototype.clear = function (tag) {
    var self = this
    if (tag) {
        var list = self.cache[tag] || sTable()
        for (var _ = 1, obj = list[1]; obj; _++ , obj = list[_]) {
            if (obj.release) obj.release()
            if (obj.cleanup) obj.cleanup()
        }
        list = self.free[tag] || sTable()
        for (var _ = 1, obj = list[1]; obj; _++ , obj = list[_]) {
            if (obj.release) obj.release()
            if (obj.cleanup) obj.cleanup()
        }
        self.cache[tag] = sTable()
        self.pawn[tag] = null
        self.free[tag] = sTable()
        self.freeSet[tag] = sTable()
    } else {
        for (var _ in self.cache) {
            var list = self.cache[_]
            if (list && $len(list) > 0) {
                for (var _ = 1, obj = list[1]; obj; _++ , obj = list[_]) {
                    if (obj.cleanup) obj.cleanup()
                    if (obj.release) obj.release()
                }
            }
        }
        for (var _ in self.free) {
            var list = self.free[_]
            if (list && $len(list) > 0) {
                for (var _ = 1, obj = list[1]; obj; _++ , obj = list[_]) {
                    if (obj.cleanup) obj.cleanup()
                    if (obj.release) obj.release()
                }
            }
        }

        self.freeSet = new Set()

        self.cache = {}
        self.free = {}
        self.pawn = {}
    }
}
